
import { Injectable } from '@angular/core';
import { HttpClientService } from '../../core/http-client/http-client.service';
import 'rxjs/add/operator/map'
@Injectable({
  providedIn: 'root'
})
export class DriverFloorService {

  private static readonly endpoint = 'DriverFloor';
  constructor(private http: HttpClientService) { }

  get(branchId: number) {
    return this.http.get<any>(`${DriverFloorService.endpoint}/GetDriverFloors/${branchId}`);
  }
 
}
